import axiosInstance from "./AxiosInstance";
import config from "../config";

const { apiAppendPath } = config;

export const handleMissedConsultation = caseId => {
    return axiosInstance.post(
        `${apiAppendPath.consultationsAppendPath}/${caseId}/missed`
    );
};